export default {
  namespaced: true,

  state: () => ({
    parsedVcfData: null,
  }),

  getters: {
    getVcfData: (state) => state.parsedVcfData,
  },

  mutations: {
    SET_VCF_DATA (state, payload) {
      state.parsedVcfData = payload
    },
    CLEAR_VCF_DATA (state) {
      state.parsedVcfData = null
    },
  },

}
